import { getExhibitorSpotlightNews } from "@/data/exhibitorSpotlight";
import { WORK_NEWS_0407 } from "@/data/news0407Generated";

const newsImage = (name) => require("@/assets/image/about-show-news/" + name);

export const ABOUT_SECTIONS = {
    intro: "intro",
    news: "news",
};

export const ABOUT_TABS = [
    { key: ABOUT_SECTIONS.intro, label: "展会介绍" },
    { key: ABOUT_SECTIONS.news, label: "工作动态" },
];

const ABOUT_LEGACY_INDEX_MAP = {
    "0": ABOUT_SECTIONS.intro,
    "1": ABOUT_SECTIONS.news,
    "2": ABOUT_SECTIONS.news,
};

export const ABOUT_INTRO_PARAGRAPHS = [
    "江苏作为东部发达省份和经济大省，产业集聚度高，建设科技成果丰富。为加强科技同经济对接、创新成果同产业对接、创新项目同现实生产力对接，江苏省住房和城乡建设厅打造了综合性、专业化、全链型服务平台——江苏绿色低碳建筑国际博览会，并获得商务部批复同意，是全省住房城乡建设领域唯一的党政机关举办展会保留清单内项目。",
    "作为行业内最具规模的优质品牌展会之一，博览会已成功举办两届，影响力持续提升。2025博览会以“科技点亮绿色城乡”为主题，展示规模近1.5万平方米，共有119家中外知名企业和机构参展，举办近50场同期活动，促成合作意向59项，涉及总金额约140亿元人民币，来自瑞典等10余个国家地区及省内外近1.7万人次参观交流，较上届增加42%。",
];

export const TALENT_DEMAND_NEWS_ID = "talent-demand-release-2026-04-06";

const ABOUT_BASE_WORK_NEWS = [
    {
        id: TALENT_DEMAND_NEWS_ID,
        title: "全省绿色低碳城乡人才线上需求发布！",
        date: "2026-04-11",
        displayDate: "2026年4月11日",
        cover: newsImage("0407_10_1.png"),
        wrapperClassName: "style-01-page",
        contentClassName: "zsml_wap",
        blocks: [
            {
                type: "paragraph",
                text: "为推动行业人才供需高效对接，全省绿色低碳城乡人才需求发布对接活动共征集线上线下上百家优质企业，共计提供超过1200个需求岗位，涵盖计算机和软件工程、土木工程、设计咨询、金融财会审计、环境工程、机电电气工程、物业管理等多个专业门类，覆盖研究生、本科、专科等各学历层次，为助力绿色低碳城乡人才队伍高质量发展提供有力支撑。",
            },
            {
                type: "paragraph",
                text: "现将本次活动征集的全省绿色低碳城乡人才线上线下需求情况统一发布，诚邀各界英才踊跃参与，筑梦绿色城乡！",
            },
            {
                type: "image",
                src: newsImage("0407_10_1.png"),
                alt: "全省绿色低碳城乡人才线上需求发布",
            },
            {
                type: "paragraph",
                text: "扫描上方二维码，获取详细岗位信息",
                className: "venue-text",
            },
        ],
        i18n: {
            en: {
                title: "Online Release of Provincial Green & Low-Carbon Urban and Rural Talent Demand!",
                displayDate: "2026.04.11",
                blocks: [
                    {
                        type: "paragraph",
                        text: "To promote efficient matching between supply and demand of industrial talents, the Provincial Green & Low-Carbon Urban and Rural Talent Demand Release & Matching Activity has collected hundreds of high-quality enterprises both online and offline. A total of more than 1,200 job vacancies are offered, covering various professional fields including computer and software engineering, civil engineering, design and consulting, finance, accounting and auditing, environmental engineering, mechanical and electrical engineering, property management, etc. The positions are available for candidates with academic qualifications ranging from postgraduate, undergraduate to junior college, providing strong support for the high-quality development of the green & low-carbon urban and rural talent team.",
                    },
                    {
                        type: "paragraph",
                        text: "The online and offline talent demand information collected in this activity is hereby released uniformly. Talents from all walks of life are sincerely invited to participate actively and pursue their dreams in green building!",
                    },
                    {
                        type: "image",
                        src: newsImage("0407_10_1.png"),
                        alt: "Online Release of Provincial Green & Low-Carbon Urban and Rural Talent Demand",
                    },
                    {
                        type: "paragraph",
                        text: "Scan the QR code above to obtain detailed job information.",
                        className: "venue-text",
                    },
                ],
            },
        },
    },
    {
        id: "construction-science-tech-release-2026-04-08",
        title: "江苏省建设科技创新成果发布暨产学研对接交流活动即将举办",
        date: "2026-04-08",
        displayDate: "2026年4月8日",
        cover: newsImage("040801_1.png"),
        wrapperClassName: "style-01-page",
        contentClassName: "zsml_wap",
        blocks: [
            {
                type: "paragraph",
                text: "为深入贯彻习近平总书记关于科技创新的重要论述，推动科技创新和产业创新深度融合，定于2026江苏绿色低碳建筑国际博览会期间，举办江苏省建设科技创新成果发布暨产学研对接交流活动。",
            },
            {
                type: "paragraph",
                text: "针对企业创新主体地位日益凸显的发展态势，系统推进激活企业创新动能，推动百余家住房城乡建设领域科技创新企业与省内高校院所，现场围绕2026技术需求，开展供需对接、洽谈交流。",
            },
            {
                type: "image",
                src: newsImage("040801_1.png"),
                alt: "江苏省建设科技创新成果发布暨产学研对接交流活动即将举办",
            },
            {
                type: "heading3",
                text: "01主要议程",
            },
            {
                type: "paragraph",
                text: "议程分为三大环节：",
            },
            {
                type: "paragraph",
                text: "14:30-15:00 主题发布+合作签约",
            },
            {
                type: "paragraph",
                text: "15:00-15:50 成果交流与需求发布",
            },
            {
                type: "paragraph",
                text: "16:00-17:30 对接洽谈",
            },
            {
                type: "heading3",
                text: "02时间地点",
            },
            {
                type: "paragraph",
                text: "时间：2026年4月9日（周四）14:00-17:30",
            },
            {
                type: "paragraph",
                text: "地点：南京国际博览中心5号展馆3号活动区",
            },
            {
                type: "paragraph",
                text: "南京国际博览中心",
            },
            {
                type: "paragraph",
                text: "江苏省南京市建邺区江东中路300号",
            },
            {
                type: "image",
                src: newsImage("040801_2.png"),
                alt: "南京国际博览中心5号馆3号活动区平面图",
            },
        ],
        i18n: {
            en: {
                title: "Jiangsu Provincial Construction Science and Technology Innovation Achievements Release & Industry-University-Research Docking Exchange Event Is Coming Soon",
                displayDate: "2026.04.08",
                blocks: [
                    {
                        type: "paragraph",
                        text: "To thoroughly implement General Secretary Xi Jinping's important expositions on scientific and technological innovation, and promote the in-depth integration of scientific and technological innovation and industrial innovation, the Jiangsu Provincial Construction Science and Technology Innovation Achievements Release & Industry-University-Research Docking Exchange Event will be held during the 2026 Jiangsu Green & Low-Carbon Building International Expo.",
                    },
                    {
                        type: "paragraph",
                        text: "In response to the growing role of enterprises as the main body of innovation, the event will systematically energize enterprise innovation and facilitate on-site supply-demand docking, negotiation and exchange between more than 100 scientific and technological innovation enterprises in the housing and urban-rural development sector and universities and research institutes in Jiangsu, focusing on the 2026 technical requirements.",
                    },
                    {
                        type: "image",
                        src: newsImage("040801_1.png"),
                        alt: "Jiangsu Provincial Construction Science and Technology Innovation Achievements Release & Industry-University-Research Docking Exchange Event",
                    },
                    {
                        type: "heading3",
                        text: "01 Main Agenda",
                    },
                    {
                        type: "paragraph",
                        text: "The agenda is divided into three major sessions:",
                    },
                    {
                        type: "paragraph",
                        text: "14:30-15:00 Thematic Release + Cooperation Signing Ceremony",
                    },
                    {
                        type: "paragraph",
                        text: "15:00-15:50 Achievements Exchange & Demand Release",
                    },
                    {
                        type: "paragraph",
                        text: "16:00-17:30 Docking & Negotiation",
                    },
                    {
                        type: "heading3",
                        text: "02 Time & Venue",
                    },
                    {
                        type: "paragraph",
                        text: "Time: 14:00-17:30, Thursday, April 9, 2026",
                    },
                    {
                        type: "paragraph",
                        text: "Venue: Activity Area 3, Hall 5, Nanjing International Expo Center",
                    },
                    {
                        type: "paragraph",
                        text: "Nanjing International Expo Center",
                    },
                    {
                        type: "paragraph",
                        text: "No. 300, Jiangdong Middle Road, Jianye District, Nanjing City, Jiangsu Province, P.R. China",
                    },
                    {
                        type: "image",
                        src: newsImage("040801_2.png"),
                        alt: "Venue map for Activity Area 3, Hall 5, Nanjing International Expo Center",
                    },
                ],
            },
        },
    },
    {
        id: "expo-opens-tomorrow-2026-04-08",
        title: "2026江苏绿色低碳建筑国际博览会明日开展！期待您的到来~",
        date: "2026-04-08",
        displayDate: "2026年4月8日",
        cover: newsImage("040802_poster.jpg"),
        wrapperClassName: "style-01-page",
        contentClassName: "zsml_wap",
        blocks: [
            {
                type: "paragraph",
                text: "2026江苏绿色低碳建筑国际博览会将于4月9日至11日在南京国际博览中心4、5号馆举办，主题为“科技创新赋能城乡高质量发展”，现已进入倒计时1天，诚邀各界朋友莅临参观。",
            },
            {
                type: "video",
                src: "/file/040802.mp4",
                alt: "2026江苏绿色低碳建筑国际博览会明日开展！期待您的到来~",
            },
            {
                type: "image",
                src: newsImage("040802_poster.jpg"),
                alt: "2026江苏绿色低碳建筑国际博览会明日开展！期待您的到来~",
            },
            {
                type: "paragraph",
                text: "请以现场实际安排为准，欢迎提前完成观展登记。",
            },
        ],
        i18n: {
            en: {
                title: "The 2026 Jiangsu Green & Low-Carbon Building International Expo Opens Tomorrow! We Look Forward to Your Arrival~",
                displayDate: "2026.04.08",
                blocks: [
                    {
                        type: "paragraph",
                        text: "The 2026 Jiangsu Green & Low-Carbon Building International Expo will be held from April 9 to 11 at Halls 4 and 5 of the Nanjing International Expo Center. With the theme of \"Technological Innovation Empowers High-Quality Urban and Rural Development\", the event is now in its final 1-day countdown. We warmly welcome you to visit.",
                    },
                    {
                        type: "video",
                        src: "/file/040802.mp4",
                        alt: "The 2026 Jiangsu Green & Low-Carbon Building International Expo Opens Tomorrow",
                    },
                    {
                        type: "image",
                        src: newsImage("040802_poster.jpg"),
                        alt: "The 2026 Jiangsu Green & Low-Carbon Building International Expo Opens Tomorrow",
                    },
                    {
                        type: "paragraph",
                        text: "Please refer to the on-site arrangements for the final schedule and details. Advance visitor registration is welcome.",
                    },
                ],
            },
        },
    },
    {
        id: "expo-opens-2026-04-10",
        title: "江苏绿色低碳建筑国际博览会开幕",
        date: "2026-04-10",
        displayDate: "2026年4月10日",
        wrapperClassName: "style-01-page",
        contentClassName: "zsml_wap",
        blocks: [
            {
                type: "paragraph",
                text: "转自：“江苏建设”微信公众平台",
            },
            {
                type: "paragraph",
                text: "4月9日，江苏省住房和城乡建设厅主办的2026江苏绿色低碳建筑国际博览会在南京国际博览中心开幕。博览会以“科技创新赋能城乡高质量发展”为主题，展示规模2.6万平方米，集中呈现国内外住房城乡建设领域绿色低碳发展新技术成果、产品和实践案例。",
            },
            {
                type: "paragraph",
                text: "博览会吸引311家优质展商参展，其中有15家世界品牌500强企业和78家上市企业。相较2023、2025博览会，2026博览会首次设立“人工智能+住房城乡建设”主题展区，从全省征集的499个应用案例中，遴选14个“人工智能+”典型案例；首次打造高品质住房展区和老房子改造综合展区，围绕新房子建成“好房子”，33家开发企业推出近百个高品质住房项目，全方位满足居民各类刚性和改善性住房需求。",
            },
            {
                type: "paragraph",
                text: "博览会持续到4月11日，将举办系列同期活动。",
            },
            {
                type: "paragraph",
                text: "（来源：新华日报）",
            },
        ],
        i18n: {
            en: {
                title: "Jiangsu Green & Low-Carbon Building International Expo Opens",
                displayDate: "2026.04.10",
                blocks: [
                    {
                        type: "paragraph",
                        text: "Reposted from: WeChat official account \"Jiangsu Construction\"",
                    },
                    {
                        type: "paragraph",
                        text: "On April 9, the 2026 Jiangsu Green & Low-Carbon Building International Expo hosted by the Jiangsu Provincial Department of Housing and Urban-Rural Development opened at Nanjing International Expo Center. With the theme of \"Technological Innovation Empowers High-Quality Urban and Rural Development\", the Expo covers an exhibition area of 26,000 square meters and presents new technologies, achievements, products and practical cases of green and low-carbon development in the housing and urban-rural development sector at home and abroad.",
                    },
                    {
                        type: "paragraph",
                        text: "The Expo attracted 311 high-quality exhibitors, including 15 Fortune Global 500 enterprises and 78 listed companies. Compared with the 2023 and 2025 editions, the 2026 Expo set up the \"Artificial Intelligence + Housing and Urban-Rural Development\" theme exhibition area for the first time. From 499 application cases collected across the province, 14 typical \"AI +\" cases were selected. It also created the high-quality housing exhibition area and the comprehensive old-house renovation exhibition area for the first time. Focusing on building \"good houses\" from new houses, 33 real estate developers launched nearly 100 high-quality housing projects to fully meet residents' rigid and improved housing needs.",
                    },
                    {
                        type: "paragraph",
                        text: "The Expo will run until April 11, with a series of concurrent events scheduled.",
                    },
                    {
                        type: "paragraph",
                        text: "(Source: Xinhua Daily)",
                    },
                ],
            },
        },
    },
    {
        id: "expo-held-in-nanjing-april-2026",
        title: "2026江苏绿色低碳建筑国际博览会将于今年4月在南京举办",
        date: "2026-01-30",
        displayDate: "2026年1月30日",
        cover: newsImage("d4e8342dfd4d7ede203f16f511eeb3aa.jpg"),
        blocks: [
            {
                type: "paragraph",
                text: "1月30日下午，省住房城乡建设厅召开2026江苏绿色低碳建筑国际博览会新闻通气会。副厅长路宏伟介绍有关工作情况。厅总工程师、绿色建筑与科技处负责同志参加发布会并回答记者提问。",
            },
            {
                type: "image",
                src: newsImage("d4e8342dfd4d7ede203f16f511eeb3aa.jpg"),
                alt: "2026江苏绿色低碳建筑国际博览会新闻通气会现场",
            },
            {
                type: "paragraph",
                text: "路宏伟介绍，为深入贯彻落实习近平总书记关于“因地制宜发展新质生产力，推动科技创新和产业创新深度融合”的重要指示精神，省住房城乡建设厅将于4月9日至11日在南京举办2026江苏绿色低碳建筑国际博览会，以“科技创新赋能城乡高质量发展”为主题，重点展示人工智能+住房城乡建设、好房子建设、城市更新、宜居韧性智慧城市、智能建造、绿色低碳建筑等最新技术和产品；同期还将举办人才招聘、推介发布、交流洽谈、培训宣贯、公益科普等多元化活动。筹备工作启动以来，省住房城乡建设厅统筹谋划、精心组织，坚持市场化原则，密集对接国内外优质展会资源。截至目前，已累计对接近300家企业，多家世界500强、行业领军以及专精特新企业确认参展。",
            },
            {
                type: "paragraph",
                text: "路宏伟表示，作为住建领域综合性、专业化、全链型服务平台，江苏绿色低碳建筑国际博览会目前已成功举办两届，对推动住房城乡建设领域科技创新与产业创新融合发展，提供了有力支撑，取得了积极成效。",
            },
            {
                type: "paragraph",
                text: "本届博览会亮点包括三点：一优化布展思路，呈现未来图景，首次采用主宾城市“1+3”模式，南京、苏州、扬州、盐城等城市结合各自产业特色组团参展，集中展现面向“十五五”的创新发展路径。同时，设置“人工智能+住房城乡建设”主题展区，生动呈现人工智能赋能城乡建设高质量发展的应用场景，推动行业监管效能增强、服务质效提升、产业转型升级；二营造创新生态，激发联动效应，开展形式丰富的同期活动，促进“政产学研金用”深度互动。邀请专家学者和领军企业代表，探索先进技术与建设场景融合应用新机制；组织企业、金融机构、科研院所等，开展科技成果转化和产业化项目签约；调动行业协会学会、商贸机构资源，促进国际和区域间合作共建；联合省有关部门，集中组织住房城乡建设行业人才招聘活动；三强化组织保障，提升办展实效，精准对接展商需求，定向组织科技创新投资、孵化、转化机构以及集中建设单位、使用单位组团观展采购，促进潜在需求落地。将博览会观展计入继续教育学时，创新全省执业注册人员学习形式。优化博览会时间安排，结合文旅宣传、科学普及、观展打卡等，让人民群众对住房城乡建设高质量发展成效更加可感可及。",
            },
            {
                type: "image",
                src: newsImage("f2a2285fb4e1ce0af46ab17d27d0d9d6.jpg"),
                alt: "2026江苏绿色低碳建筑国际博览会新闻通气会现场全景",
            },
            {
                type: "paragraph",
                text: "路宏伟表示，江苏绿色低碳建筑国际博览会作为面向住房城乡建设全领域的综合平台，将继续以服务创新发展为导向，聚焦科技赋能，注重平台聚力，强化供需对接，推动产业发展，不断催化科技创新这一“关键变量”持续转化为高质量发展的“最大增量”，为加快培育住房城乡建设新质生产力注入强劲新动能。",
            },
        ],
    },
    {
        id: "visit-danish-consul-general",
        title: "费少云拜访丹麦王国驻上海总领事严慕白",
        date: "2025-09-24",
        displayDate: "2025年9月24日",
        cover: newsImage("bc9324842e643182f271a3b84114c329.jpg"),
        blocks: [
            {
                type: "paragraph",
                text: "9月18日，省住房城乡建设厅党组书记费少云赴上海拜访丹麦王国驻上海总领事馆总领事严慕白（Jens Martin Alsbirk），副厅长路宏伟参加座谈。",
            },
            {
                type: "paragraph",
                text: "费少云回顾了近年来江苏与丹麦的合作历程，介绍了我省在城乡建设绿色发展、城市品质提升、智慧城市建设、智能建造等方面的成果，欢迎丹麦代表团参加2026江苏绿色低碳建筑国际博览会，表示江苏住建部门将持续深化双边合作，推动绿色低碳建筑、城市更新、高品质住房等领域技术合作和企业交流。",
            },
            {
                type: "paragraph",
                text: "严慕白表示，丹麦王国驻上海总领事馆愿意积极组织丹麦企业参加2026江苏绿色低碳建筑国际博览会，开展技术研讨和业务对接，并期待与江苏在城乡建设绿色低碳发展等方面进一步深化合作交流。丹麦王国驻华大使馆商务参赞马经纶（Martin Joergensen）、驻沪总领事馆商务官员潘巧群参加会议。厅驻上海办事处、绿色建筑与科技处、科技发展中心负责同志参加会议。",
            },
            {
                type: "image",
                src: newsImage("bc9324842e643182f271a3b84114c329.jpg"),
                alt: "费少云拜访丹麦王国驻上海总领事严慕白",
            },
        ],
    },
    {
        id: "expo-preview-notice-2026",
        title: "请查收！2026江苏绿色低碳建筑国际博览会预通知来了~",
        date: "2025-09-13",
        displayDate: "2025年9月13日",
        cover: newsImage("3-2.png"),
        blocks: [
            {
                type: "paragraph",
                text: "江苏绿色低碳建筑国际博览会自2023年举办以来，已成功举办两届。博览会作为我省住房城乡建设领域综合性、专业化、全链型服务平台，通过技术推广、产品交易、项目对接、产金合作、人才交流等多元举措，有效推动创新链产业链资金链人才链深度融合，受到社会各界的广泛关注和一致好评。",
            },
            {
                type: "paragraph",
                text: "为进一步推动江苏住房城乡建设领域科技创新与产业创新融合发展，促进要素与市场对接，经研究，江苏省住房和城乡建设厅拟于明年4月举办2026江苏绿色低碳建筑国际博览会，现将有关事项通知如下：一、活动内容：展示国内外住房城乡建设领域绿色低碳发展最新技术成果、产品和实践案例，同期开展技术交流、商务洽谈、推介发布、宣贯培训等活动。二、时间：2026年4月8日至10日，地点：南京国际博览中心（建邺区江东中路300号）。三、观展对象：省内外住房城乡建设主管部门相关人员；省城乡建设碳达峰碳中和先导区、绿色城区项目实施单位相关人员；高校院所、科研机构、学会协会相关人员；从事绿色低碳建筑建设、生产、设计、施工、运营、咨询的企业相关人员；绿色金融机构相关人员。四、联系方式：招展工作，陈潇阳：025-51868170，15850576018；周慧群：025-52856795，15295583680。会务工作，唐甜：025-51868252，19816405336；张天迪：025-51868143，15366070676；李敏文：025-52856497，15605184888。五、其他：1.博览会不收取任何会务费用，观展人员食宿自理；2.更多详细资讯，请关注“绿色城乡建设”公众号推送内容。",
            },
            {
                type: "paragraph",
                text: "国际博览会盛况回顾：名企云集 前沿科技集中呈现，吸引多家世界品牌、500强企业、上市公司、境外知名企业参展，重点展现新能源、新材料、数字化、智能化、先进制造等技术在建筑领域融合创新成果。聚焦住房城乡建设高质量发展重点工作，围绕住宅品质提升、智能建造、城市更新等行业发展的热点领域开设专题展区；开放平台 促进国际化交流互动，邀请英国、法国、德国、意大利、瑞士、荷兰、芬兰、加拿大等国际机构、省内外相关组织及行业领军企业参展参会，打造高端国际交流平台，促进建设科技成果转化，加快住房城乡建设领域创新链、产业链、资金链、人才链深度融合；活动纷呈 促进产研深度融合，吸引行业学会协会、参展单位举办推介发布、技术交流、商务洽谈、学术研讨等活动，国际国内专家学者、行业机构领军人物及相关主管部门代表围绕行业热点开展研讨，促进“政产学研金用”全链互动；精准对接 助力业务拓展资源转化，吸引海内外政府机构、行业协会、科研院所及产业链企业等专业观众，展商在现场洽谈对接目标客户。打造“永不落幕”的展会，持续提供需求对接、合作意向追踪等全链条服务，助力展商持续挖掘潜在商机，实现长效资源转化；全媒体赋能 打造立体宣传矩阵，荔枝新闻等多家专业媒体，对参展企业进行专题采访报道；开展全程直播，行业专家、企业代表、专业观众近距离交流互动；“江苏建设”“绿色城乡建设”微信公众号及时推送博览会动态；公众媒体、行业媒体等进行全方位宣传报道，打造立体传播矩阵。",
            },
            {
                type: "image",
                src: newsImage("3-2.png"),
                alt: "2026江苏绿色低碳建筑国际博览会预通知",
                caption: "部分图片素材来源荔枝新闻",
            },
        ],
    },
    {
        id: "expo-registration-open-2026",
        title: "2026江苏绿色低碳建筑国际博览会开始报名！",
        date: "2026-03-09",
        displayDate: "2026年3月9日",
        cover: newsImage("new5-3.png"),
        wrapperClassName: "style-01-page",
        contentClassName: "zsml_wap",
        blocks: [
            {
                type: "paragraph",
                text: "为深入贯彻党的二十大和二十届历次全会精神，落实省委、省政府关于建成高水平科技强省的部署要求，推动住房城乡建设领域科技创新与产业创新融合发展，打造综合性、专业化、全链型服务平台，经批准，我厅将举办2026江苏绿色低碳建筑国际博览会。现将有关事项通知如下：",
            },
            {
                type: "heading3",
                text: "01时间和地点",
            },
            {
                type: "paragraph",
                text: "时间：2026年4月9日-11日",
            },
            {
                type: "paragraph",
                text: "地点：南京国际博览中心4、5号馆（南京市江东中路300号）",
            },
            {
                type: "heading3",
                text: "02展会内容",
            },
            {
                type: "paragraph",
                text: "2026江苏绿色低碳建筑国际博览会以“科技创新赋能城乡高质量发展”为主题，重点展示人工智能+住房城乡建设、好房子建设、城市更新、宜居韧性智慧城市、智能建造、历史文化保护传承、绿色低碳建筑等国内外最新技术、产品和实践案例。同期还将开展人才招聘、推介发布、技术交流、对接洽谈、公众互动等多元化活动，详情见博览会组委会办公室后续印发的具体活动通知。",
            },
            {
                type: "heading3",
                text: "03参加人员",
            },
            {
                type: "paragraph",
                text: "省内外住房城乡建设主管部门、行业学会协会相关人员",
            },
            {
                type: "paragraph",
                text: "行业领域投资、建设、生产、设计、施工、运维、科研、咨询、信息服务等企事业单位代表和从业人员",
            },
            {
                type: "paragraph",
                text: "服贸、金融、能源、养老等城乡建设相关行业的企业代表和从业人员",
            },
            {
                type: "paragraph",
                text: "关注住房城乡建设高质量发展的专家、学者和社会大众",
            },
            {
                type: "heading3",
                text: "04其他事项",
            },
            {
                type: "heading4",
                text: "报名方式",
            },
            {
                type: "paragraph",
                text: "报名观展以及了解详细资讯请关注“江苏建设”公众号，长按识别下方二维码进入报名页面。",
            },
            {
                type: "image",
                src: newsImage("new5-1.png"),
                alt: "2026江苏绿色低碳建筑国际博览会报名二维码",
                wrapperClassName: "zsfc_logo",
            },
            {
                type: "heading4",
                text: "联系方式",
            },
            {
                type: "paragraph",
                text: "025-51868653、51868252",
            },
            {
                type: "paragraph",
                text: "本次活动不收取会务费用，食宿自理。",
            },
            {
                type: "heading4",
                text: "住宿参考信息",
            },
            {
                type: "image",
                src: newsImage("new5-2.png"),
                alt: "住宿参考信息",
            },
            {
                type: "heading4",
                text: "交通参考信息",
            },
            {
                type: "image",
                src: newsImage("new5-3.png"),
                alt: "交通参考信息",
            },
            {
                type: "heading4",
                text: "展馆地址",
            },
            {
                type: "paragraph",
                text: "📍南京国际博览中心4、5号馆",
            },
            {
                type: "paragraph",
                text: "南京国际博览会议中心",
            },
            {
                type: "paragraph",
                text: "（江苏省南京市建邺区江东中路300号）",
            },
            {
                type: "heading4",
                text: "交通指引",
            },
            {
                type: "paragraph",
                html: "<strong>南京地铁：</strong>",
            },
            {
                type: "paragraph",
                text: "乘坐南京地铁10号、2号线均在元通站下，4号出口出站。",
            },
            {
                type: "paragraph",
                html: "<strong>南京公交：</strong>",
            },
            {
                type: "paragraph",
                text: "乘坐85路、134路元通站下车。",
            },
            {
                type: "paragraph",
                html: "<strong>南京市区车辆：</strong>",
            },
            {
                type: "paragraph",
                html: "&#9658;<strong>城东、城南方向：</strong>龙蟠中路－双桥门立交－应天大街－江东中路-南京国际博览中心。",
            },
            {
                type: "paragraph",
                html: "&#9658;<strong>城西、城北方向：</strong>江东中路-南京国际博览中心。",
            },
            {
                type: "paragraph",
                html: "<strong>外地车辆：</strong>",
            },
            {
                type: "paragraph",
                text: "接近南京时进入南京绕城高速，宁西立交桥（江东南路/奥体中心306B）出口—江山大道（1260米右转）—江东中路（直行830米）即到南京国际博览会议中心东门。",
            },
            {
                type: "paragraph",
                html: "<strong>机 场：</strong>",
            },
            {
                type: "paragraph",
                html: "<strong>机场大巴或机场线地铁到市区再换乘或乘出租车。</strong>",
            },
            {
                type: "paragraph",
                html: "&#9658;<strong>机场1号线（城东线）</strong>：从早上08:00至当天最后一个航班结束，下客站为翠屏山宾馆、雨花广场、秦虹桥、七里街、龙蟠中路逸仙桥、南京火车站。乘此线到雨花广场改乘出租车或到南京火车站换乘地铁。",
            },
            {
                type: "paragraph",
                html: "&#9658;<strong>机场2号线（河西线）</strong>：从上午09:00至23:35。下客站为南京南站、金奥中心、梦都大街、兴隆大街、集庆门大街、新城市广场。乘此线到南京南站换乘地铁或出租。",
            },
            {
                type: "paragraph",
                html: "&#9658;<strong>机场3号线（夫子庙线）</strong>：从上午9:30至20:35。下客站为中华门、夫子庙、金陵饭店。",
            },
            {
                type: "paragraph",
                text: "机场线地铁到南京南站换乘。",
            },
            {
                type: "paragraph",
                html: "<strong>火 车：</strong>",
            },
            {
                type: "paragraph",
                html: "&#9658;南京火车站出站乘地铁1号线到新街口换乘2号线到元通站下，4号出口出站。",
            },
            {
                type: "paragraph",
                html: "&#9658;南京南站出站乘地铁1号线到安德门换乘10号线到元通站下，4号出口出站。",
            },
        ],
        i18n: {
            en: {
                title: "Registration Open for 2026 Jiangsu Green & Low-Carbon Buildings International Expo",
                displayDate: "2026.03.09",
                blocks: [
                    {
                        type: "paragraph",
                        text: "To fully implement the spirits of the 20th National Congress of the Communist Party of China and the subsequent plenary sessions, carry out the requirements of the Jiangsu Provincial Party Committee and Provincial Government for building a province strong in science and technology, promote the integrated development of technological innovation and industrial innovation in the housing and urban-rural construction sector, and build a comprehensive, professional and full-industry-chain service platform, our department has been approved to host 2026 Jiangsu Green & Low-Carbon Buildings International Expo. Relevant arrangements are hereby announced as follows:",
                    },
                    {
                        type: "heading3",
                        text: "01 Date & Venue",
                    },
                    {
                        type: "paragraph",
                        text: "Date: April 9 - 11, 2026",
                    },
                    {
                        type: "paragraph",
                        text: "Venue: Hall 4 & 5, Nanjing International Expo Center (No. 300 Jiangdong Middle Road, Nanjing)",
                    },
                    {
                        type: "heading3",
                        text: "02 Expo Highlights",
                    },
                    {
                        type: "paragraph",
                        text: "With the theme of \"Sci-Tech Innovation Empowers High-Quality Urban and Rural Development\", 2026 Jiangsu Green & Low-Carbon Buildings International Expo focuses on displaying the latest domestic and international technologies, products and practical cases covering AI application in housing and urban-rural construction, quality housing development, urban renewal, livable and resilient smart cities, intelligent construction, conservation and inheritance of historical culture, and green and low-carbon buildings. A variety of supporting activities will be held simultaneously, including talent recruitment, product promotion conferences, technical exchanges, business matchmaking negotiations and public interactive sessions. For detailed arrangements, please refer to the official notices issued later by the Expo Organizing Committee Office.",
                    },
                    {
                        type: "heading3",
                        text: "03 Participants",
                    },
                    {
                        type: "paragraph",
                        text: "Staff from housing and urban-rural construction authorities, industry societies and associations inside and outside Jiangsu Province;",
                    },
                    {
                        type: "paragraph",
                        text: "Representatives and practitioners of enterprises and institutions engaged in investment, construction, manufacturing, design, engineering, operation and maintenance, scientific research, consulting and information services in the construction industry;",
                    },
                    {
                        type: "paragraph",
                        text: "Personnel from enterprises in service trade, finance, energy, elderly care and other sectors related to urban and rural construction;",
                    },
                    {
                        type: "paragraph",
                        text: "Experts, scholars and the general public concerned about the high-quality development of housing and urban-rural construction.",
                    },
                    {
                        type: "heading3",
                        text: "04 Miscellaneous Information",
                    },
                    {
                        type: "heading4",
                        text: "Registration",
                    },
                    {
                        type: "paragraph",
                        text: "To register for admission and obtain detailed information, please follow the WeChat official account \"Jiangsu Construction\". Long press to scan the QR code below and enter the registration page.",
                    },
                    {
                        type: "paragraph",
                        text: "QR Code for the 2026 Jiangsu International Expo on Green and Low-Carbon Buildings Registration",
                    },
                    {
                        type: "image",
                        src: newsImage("new5-1.png"),
                        alt: "Registration QR Code for 2026 Jiangsu Green & Low-Carbon Buildings International Expo",
                        wrapperClassName: "zsfc_logo",
                    },
                    {
                        type: "heading4",
                        text: "Contact Information",
                    },
                    {
                        type: "paragraph",
                        text: "Tel: 025-51868653, 51868252",
                    },
                    {
                        type: "paragraph",
                        text: "No registration fee will be charged. Accommodation and meals are at the participant's own expense.",
                    },
                    {
                        type: "heading4",
                        text: "Accommodation Reference Information",
                    },
                    {
                        type: "image",
                        src: newsImage("new5-2.png"),
                        alt: "Accommodation Reference Information",
                    },
                    {
                        type: "heading4",
                        text: "Traffic Reference Information",
                    },
                    {
                        type: "image",
                        src: newsImage("new5-3.png"),
                        alt: "Traffic Reference Information",
                    },
                    {
                        type: "heading4",
                        text: "Venue Address",
                    },
                    {
                        type: "paragraph",
                        text: "Hall 4 & 5, Nanjing International Expo Center",
                    },
                    {
                        type: "paragraph",
                        text: "Nanjing International Expo Conference Center",
                    },
                    {
                        type: "paragraph",
                        text: "(No. 300 Jiangdong Middle Road, Jianye District, Nanjing, Jiangsu Province)",
                    },
                    {
                        type: "heading4",
                        text: "Traffic Guide",
                    },
                    {
                        type: "paragraph",
                        html: "<strong>Nanjing Metro:</strong>",
                    },
                    {
                        type: "paragraph",
                        text: "Take Nanjing Metro Line 2 or Line 10 to Yuantong Station and exit via Exit 4.",
                    },
                    {
                        type: "paragraph",
                        html: "<strong>Nanjing Bus:</strong>",
                    },
                    {
                        type: "paragraph",
                        text: "Take Bus No. 85 or No. 134 and get off at Yuantong Stop.",
                    },
                    {
                        type: "paragraph",
                        html: "<strong>Vehicles in Urban Nanjing:</strong>",
                    },
                    {
                        type: "paragraph",
                        text: "From East & South Nanjing: Longpan Middle Road -> Shuangqiaomen Overpass -> Yingtian Street -> Jiangdong Middle Road -> Nanjing International Expo Center.",
                    },
                    {
                        type: "paragraph",
                        text: "From West & North Nanjing: Jiangdong Middle Road -> Nanjing International Expo Center.",
                    },
                    {
                        type: "paragraph",
                        html: "<strong>Vehicles from Outside Nanjing:</strong>",
                    },
                    {
                        type: "paragraph",
                        text: "When approaching Nanjing, enter Nanjing Ring Expressway, exit at Ningxi Overpass (Jiangdong South Road/Olympic Sports Center, Exit 306B) -> Jiangshan Avenue (turn right after 1260 meters) -> Jiangdong Middle Road (go straight for 830 meters) to reach the East Gate of Nanjing International Expo Conference Center.",
                    },
                    {
                        type: "paragraph",
                        html: "<strong>Airport:</strong>",
                    },
                    {
                        type: "paragraph",
                        text: "Take the airport shuttle bus or airport metro to downtown for transfer, or take a taxi directly.",
                    },
                    {
                        type: "paragraph",
                        text: "Airport Line 1 (East City Route): Operating from 08:00 to the last flight of the day. Stops include Cuipingshan Hotel, Yuhua Square, Qinhong Bridge, Qilijie, Yixian Bridge on Longpan Middle Road and Nanjing Railway Station. Transfer by taxi at Yuhua Square or take the metro at Nanjing Railway Station.",
                    },
                    {
                        type: "paragraph",
                        text: "Airport Line 2 (Hexi Route): Operating from 09:00 to 23:35. Stops include Nanjing South Railway Station, Jin'ao Center, Mengdu Street, Xinglong Street, Jiqingmen Street and New City Plaza. Transfer by metro or taxi at Nanjing South Railway Station.",
                    },
                    {
                        type: "paragraph",
                        text: "Airport Line 3 (Confucius Temple Route): Operating from 09:30 to 20:35. Stops include Zhonghua Gate, Confucius Temple and Jinling Hotel.",
                    },
                    {
                        type: "paragraph",
                        text: "Take the airport metro to Nanjing South Railway Station for transfer.",
                    },
                    {
                        type: "paragraph",
                        html: "<strong>Railway Station:</strong>",
                    },
                    {
                        type: "paragraph",
                        text: "Nanjing Railway Station: After exiting, take Metro Line 1 to Xinjiekou, transfer to Line 2 and alight at Yuantong Station (Exit 4).",
                    },
                    {
                        type: "paragraph",
                        text: "Nanjing South Railway Station: After exiting, take Metro Line 1 to Andemen, transfer to Line 10 and alight at Yuantong Station (Exit 4).",
                    },
                ],
            },
        },
    },
    {
        id: "international-guests-praise-2025-expo",
        title: "国际人士盛赞2025江苏绿色低碳建筑国际博览会",
        date: "2025-04-03",
        displayDate: "2025年4月3日",
        cover: newsImage("4-1.jpg"),
        blocks: [
            {
                type: "paragraph",
                text: "4月2日，省住房城乡建设厅厅长王学锋在南京会见参加2025江苏绿色低碳建筑国际博览会有关活动的瑞典驻上海总领事（大使衔）司梅，并陪同观展。双方就深化瑞典与江苏合作，共同推动建设科技创新与产业创新合作，共享绿色技术经验等进行深入交流。",
            },
            {
                type: "image",
                src: newsImage("4-1.jpg"),
                alt: "国际人士盛赞2025江苏绿色低碳建筑国际博览会",
            },
            {
                type: "paragraph",
                text: "2025江苏绿色低碳建筑国际博览会由省住房城乡建设厅主办。活动期间，来自瑞典、英国、意大利、荷兰、澳大利亚、加拿大等十余个国家的五十余名外国专家学者、科研机构代表、企业代表，参观了改善型住宅、智能建造、绿色基础设施等8个特色展区，与展商交流洽谈，达成多项合作意向。",
            },
            {
                type: "paragraph",
                text: "国际人士代表声音：",
            },
            {
                type: "paragraph",
                text: "司梅 瑞典驻上海总领事（大使衔）",
            },
            {
                type: "paragraph",
                text: "博览会展现了江苏在绿色低碳建筑领域的卓越创新与实践，令人印象深刻。瑞典在可持续发展领域的创新与江苏绿色低碳发展路径高度契合，期待明年博览会上见到更多的“瑞典元素”。",
            },
            {
                type: "paragraph",
                text: "米凯尔 瑞典皇家理工大学副校长、教授",
            },
            {
                type: "paragraph",
                text: "博览会汇聚了中国的前沿技术，政产学研金用深度融合，令人振奋。我们希望与江苏高校、科研单位深化绿色低碳设计、绿色建材等领域合作，共塑可持续未来。",
            },
            {
                type: "paragraph",
                text: "董威廉 荷兰贸促会南京代表处首席代表",
            },
            {
                type: "paragraph",
                text: "本次博览会展示了许多建筑领域前沿科技产品，为中国与国外企业提供了高效对接桥梁，荷兰展团深入参与技术研讨与商务洽谈，期待荷兰、江苏在绿色建筑方面开展更多深入合作。",
            },
            {
                type: "paragraph",
                text: "韦祖良 澳纽工商联合总会会长",
            },
            {
                type: "paragraph",
                text: "博览会展示的技术领先、场景丰富，为全球绿色低碳转型提供了务实的解决方案。澳纽商会将积极推动澳苏企业对接，引进优质绿色建材、智能技术等，深化中澳产业合作，共拓绿色商机。",
            },
            {
                type: "paragraph",
                text: "杨丽莉 安施洁品牌中国大区总代理、总经理",
            },
            {
                type: "paragraph",
                text: "博览会作为国际企业在江苏的展示窗口，为企业和产品上下游合作伙伴供需对接、资源匹配、业务拓展创造了难得机会。期待明年能够继续参加。",
            },
            {
                type: "paragraph",
                text: "作为江苏住房城乡建设领域的综合性、专业化、全链型国际交流平台，省住房城乡建设厅将以博览会为重要平台，持续深化国际合作，推动创新链、产业链、资金链、人才链深度融合，助力绿色低碳新兴产业和未来产业发展，为经济大省“挑大梁”提供有力支撑。",
            },
        ],
    },
];

const hydrate0407WorkBlocks = (blocks = []) =>
    blocks.map((block) => {
        if (!block) {
            return block;
        }

        if (block.type === "image" && block.src) {
            return {
                ...block,
                src: newsImage(block.src),
            };
        }

        if (block.type === "image-group" && Array.isArray(block.images)) {
            return {
                ...block,
                images: block.images.map((image) => ({
                    ...image,
                    src: image && image.src ? newsImage(image.src) : image.src,
                })),
            };
        }

        return block;
    });

const hydrateLocalizedBlocks = (localized = {}) => {
    if (!localized || typeof localized !== "object") {
        return localized;
    }

    return Object.keys(localized).reduce((result, locale) => {
        const payload = localized[locale];

        if (!payload || typeof payload !== "object") {
            result[locale] = payload;
            return result;
        }

        result[locale] = {
            ...payload,
            blocks: hydrate0407WorkBlocks(payload.blocks || []),
        };

        return result;
    }, {});
};

const ABOUT_NEWS_0407 = WORK_NEWS_0407.map((item) => ({
    ...item,
    cover: item.cover ? newsImage(item.cover) : undefined,
    blocks: hydrate0407WorkBlocks(item.blocks),
    i18n: hydrateLocalizedBlocks(item.i18n),
}));

const buildAboutSpotlightWorkNews = (locale = "zh") =>
    getExhibitorSpotlightNews(locale).map((item) => ({
        ...item,
        wrapperClassName: item.wrapperClassName || "spotlight-work-page",
        contentClassName: item.contentClassName || "spotlight-work-content",
    }));

const PINNED_ABOUT_NEWS_IDS = [
];

const compareAboutNews = (left, right) => {
    const leftPinned = PINNED_ABOUT_NEWS_IDS.includes(left.id);
    const rightPinned = PINNED_ABOUT_NEWS_IDS.includes(right.id);

    if (leftPinned !== rightPinned) {
        return leftPinned ? -1 : 1;
    }

    return right.date.localeCompare(left.date);
};

const normalizeLocale = (locale) => (locale === "en" ? "en" : "zh");

const resolveAboutLocalizedPayload = (article = {}) => {
    const localized = article.i18n || {};
    const zh = localized.zh || {};
    const en = localized.en || {};

    return {
        zh: {
            title: zh.title || article.title || "",
            displayDate: zh.displayDate || article.displayDate || "",
            blocks: zh.blocks || article.blocks || [],
        },
        en: {
            title: en.title || "",
            displayDate: en.displayDate || "",
            blocks: en.blocks || [],
        },
    };
};

const localizeAboutNewsItem = (article, locale = "zh") => {
    const normalizedLocale = normalizeLocale(locale);
    const payload = resolveAboutLocalizedPayload(article);

    if (normalizedLocale === "en") {
        const hasEnglishContent =
            Boolean(payload.en.title) &&
            Array.isArray(payload.en.blocks) &&
            payload.en.blocks.length > 0;

        if (hasEnglishContent) {
            return {
                ...article,
                ...payload.en,
                hasEnglishContent: true,
            };
        }

        return {
            ...article,
            ...payload.zh,
            hasEnglishContent: false,
        };
    }

    return {
        ...article,
        ...payload.zh,
        hasEnglishContent: false,
    };
};

export function getAboutWorkNews(locale = "zh") {
    const normalizedLocale = normalizeLocale(locale);

    return [
        ...ABOUT_BASE_WORK_NEWS.map((item) =>
            localizeAboutNewsItem(item, normalizedLocale)
        ),
        ...ABOUT_NEWS_0407.map((item) =>
            localizeAboutNewsItem(item, normalizedLocale)
        ),
        ...buildAboutSpotlightWorkNews(locale),
    ].sort(compareAboutNews);
}

export const ABOUT_WORK_NEWS = getAboutWorkNews();

export function findAboutNewsById(id, locale = "zh") {
    return getAboutWorkNews(locale).find((item) => item.id === id) || null;
}

export function normalizeAboutSection(query = {}) {
    if (query.section && ABOUT_TABS.some((item) => item.key === query.section)) {
        return query.section;
    }

    if (query.article && findAboutNewsById(query.article)) {
        return ABOUT_SECTIONS.news;
    }

    if (
        query.index !== undefined &&
        ABOUT_LEGACY_INDEX_MAP[String(query.index)]
    ) {
        return ABOUT_LEGACY_INDEX_MAP[String(query.index)];
    }

    return ABOUT_SECTIONS.intro;
}

export function buildAboutQuery(section, article) {
    const query = {
        section,
    };

    if (section === ABOUT_SECTIONS.news && article) {
        query.article = article;
    }

    return query;
}
